import React from 'react'

import * as Styled from './styles'

interface Props {
  htmlFor: string
  disabled?: boolean
  label: string
  info?: string
  children: React.ReactNode
}

const SwitchLabel: React.FC<Props> = ({ htmlFor, disabled = false, label, info = '', children }) => {
  return (
    //@ts-expect-error // TODO
    <Styled.SwitchLabel htmlFor={htmlFor} disabled={disabled}>
      <Styled.Texts>
        {label} {info && <span className="info">{info}</span>}
      </Styled.Texts>

      {children}
    </Styled.SwitchLabel>
  )
}

SwitchLabel.defaultProps = {
  disabled: false,
  info: '',
}

export default SwitchLabel
